import React, { Component } from 'react';
import { withRouter, Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';

export class SteppedFlow extends Component {
  constructor(props) {
    super(props);

    this.state = { step: -1 };

    this.routes = this.makeRoutes(props, true);
  }

  makeRoutes = (props, inConstructor) => {
    return props.steps.map((data, i, original) => {
      if (props.location.pathname.indexOf(`${props.basePath}${data.path}`) === 0) {
        if (inConstructor) {
          this.state = { step: i };
        } else {
          this.setState({ step: i });
        }
      }
      const { path, component, ...otherProps } = data;
      const routeProps = { onCancel: this.props.onCancel };
      if (i != 0) {
        routeProps['onBack'] = () => {
          this.handleTransition(original[i - 1].path);
        };
      }
      if (i != original.length - 1) {
        routeProps['onContinue'] = () => {
          this.handleTransition(original[i + 1].path);
        };
      }
      const proppedComponent = React.createElement(component, {
        wrapper: React.cloneElement(props.actionWrapper, { ...otherProps }),
        ...routeProps,
        ...otherProps,
      });
      const isExact = path == '';
      return (
        <Route
          exact={isExact}
          key={`${props.basePath}${path}`}
          path={`${props.basePath}${path}`}
          render={props => {
            return React.cloneElement(proppedComponent, { ...props });
          }}
        />
      );
    });
  };

  componentWillReceiveProps(props) {
    if (props.steps !== this.props.steps) {
      this.routes = this.makeRoutes(props);
    }

    for (const [i, r] of props.steps.entries()) {
      if (`${props.basePath}${r.path}` == props.location.pathname) {
        this.setState({ step: i });
        return;
      }
    }
  }

  handleTransition(path) {
    const { beforeRoute } = this.props;
    if (beforeRoute) {
      beforeRoute(path).then(this._doTransition(path));
    } else {
      this._doTransition(path);
    }
  }

  _doTransition(path) {
    const { history, basePath } = this.props;
    if (path == 'complete') {
      history.push('/dashboard');
    } else {
      history.push(`${basePath}${path}`);
    }
  }

  render() {
    if (this.state.step == -1) {
      return null;
    }
    const { path, component, disableStepWrapper, ...otherProps } = this.props.steps[this.state.step];
    if (!disableStepWrapper) {
      return React.cloneElement(this.props.stepWrapper, {
        children: <Switch>{this.routes}</Switch>,
        step: this.state.step,
        ...otherProps,
      });
    } else {
      return (
        <div>
          <Switch>{this.routes}</Switch>
        </div>
      );
    }
  }
}
export default withRouter(SteppedFlow);
